

// Show password
const togglePassword = document.querySelector('.togglePassword');
const password = document.querySelector('.CustomerPassword');
if(togglePassword && password)
{
  togglePassword.addEventListener('click', function (e) {
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
    this.classList.toggle('show-password');
  });
}
initEventListeners();
// Show password
const togglePassword2 = document.querySelector('#confirm-password');
const password2 = document.querySelector('#ForgotPassword');
if(togglePassword2 && password2) {
  togglePassword2.addEventListener('click', function (e) {
    const type = password2.getAttribute('type') === 'password' ? 'text' : 'password';
    password2.setAttribute('type', type);
    this.classList.toggle('show-password');
  });
}

// custom reset pass //

function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }
function toggleRecoverPasswordForm() {
  var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
  var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
}


function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
}

// custom reset pass //
